import React from 'react';
import {
    Switch,
    Route,
    Redirect,
    RouteProps,
    withRouter,
} from 'react-router';
import { hasAccessTokenInLocalStorage, createReturnUrl, getReturnUrl } from '_helpers';
import { IRootState } from '../redux/store/configureStore';
import { connect } from 'react-redux';
import UnAuthorizedHandler from './UnAuthorizedHandler';
import AuthorizedHandler from './AuthorizedHandler';

const Routes = () => {
    if (hasAccessTokenInLocalStorage()) {
        const returnUrl = getReturnUrl();

        return (
            <Switch>
                {returnUrl && <Redirect to={returnUrl} />}
                <Redirect path="/login" to="/" />
                <Redirect exact path="/" to="/asc-participate" />

                <Route
                  path="/"
                  render={({ location }) => (
                        <AuthorizedHandler location={location} />
                    )}
                />
            </Switch>
        );
    }

    createReturnUrl();

    return (
        <Switch>
            <Route
              path="/"
              render={({ location }) => (
                    <UnAuthorizedHandler location={location} />
                )}
            />
            <Redirect to="/login" />
        </Switch>
    );
};
const mapState = (state: IRootState) => ({
    auth: state.auth.auth,
});

export default (withRouter(connect(mapState)(Routes))) as React.ComponentType<Props | RouteProps>;

type connectedProps = ReturnType<typeof mapState>;

type Props = connectedProps;
